import React from 'react';

import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import PropTypes from 'prop-types';

import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';

import { MARK_LABEL_VARIANT } from './PreviewMarkBadge.constants';

/**
 * A number in the change marks' pill: a mark's number, the same on the page and in the list of
 * changes, or a page's count of marks in the page rail.
 */
const PreviewMarkBadge = ({
  number,
  dataTestId = FormChangeHistoryTestIds.PREVIEW_MARK_NUMBER,
}) => (
  <LabelCDS
    dataTestId={dataTestId}
    size={LabelSize.S}
    title={String(number)}
    variant={MARK_LABEL_VARIANT}
  />
);

PreviewMarkBadge.propTypes = {
  number: PropTypes.number.isRequired,
  dataTestId: PropTypes.string,
};

export default PreviewMarkBadge;
